import { render, staticRenderFns } from "./multi-select.vue?vue&type=template&id=309d51be&"
import script from "./multi-select.vue?vue&type=script&lang=js&"
export * from "./multi-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports